var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"container-content"},[_c('div',{staticClass:"page-header"},[_c('h4',{staticClass:"page-header-text"},[_vm._v(_vm._s(_vm.$t('pages.policy.heading')))])]),_c('PrivacyPolicyContent',{attrs:{"hideHeader":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }